// extracted by mini-css-extract-plugin
module.exports = {"container":"chords_container__3Urtk","hideDiagram":"chords_hideDiagram__3C58Q","editGroup":"chords_editGroup__OTYu5","skeleton_animate":"chords_skeleton_animate__bI_2A"};